<template>
  <div>
    <el-tabs v-model="subsidyFlag" @tab-click="search">
        <el-tab-pane label="商户补贴" name="merchant"></el-tab-pane>
        <el-tab-pane label="代理商补贴" name="agent"></el-tab-pane>
      </el-tabs>
    <module-card title="筛选">
      <el-form :inline="true" :model="searchForm" v-show="subsidyFlag === 'merchant'">
        <el-form-item label="打款时间">
          <date-range-picker :value="payTime" @change="value => payTime = value" ref="payTime" @getChange="dateChange" :maxRange="31" :disabledBefore="disabledBefore"></date-range-picker>
        </el-form-item>
        <el-form-item label="打款单号">
          <el-input v-model.trim="searchForm.billId" clearable placeholder="请输入打款单号"></el-input>
        </el-form-item>
        <el-form-item label="活动编号">
          <el-input v-model.trim="searchForm.activityId" clearable placeholder="请输入活动编号"></el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <!-- <el-select clearable v-model="searchForm.activityName" placeholder="请选择活动名称" filterable>
            <el-option v-for="item in activityList" :key="item.code" :label="item.name" :value="item.name"/>
          </el-select> -->
          <el-autocomplete
          v-model="searchForm.activityName"
          :fetch-suggestions="querySearch"
          placeholder="请输入活动名称"
          :trigger-on-focus="false"
          value-key="name"
          clearable
          style="width: 202px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="银行名称">
          <el-input v-model.trim="searchForm.bankName" clearable placeholder="请输入银行名称"></el-input>
        </el-form-item>
        <el-form-item label="银行编号">
          <el-input v-model.trim="searchForm.bankCode" clearable placeholder="请输入银行编号"></el-input>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input v-model.trim="searchForm.merchantId" clearable placeholder="请输入商户编号"></el-input>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model.trim="searchForm.agentId1g" clearable placeholder="请输入代理商编号"></el-input>
        </el-form-item>
        <el-form-item label="直属代理商编号">
          <el-input v-model.trim="searchForm.agentId" clearable placeholder="请输直属代理商编号"></el-input>
        </el-form-item>
        <el-form-item label="活动类型">
          <el-select clearable v-model="searchForm.activityType">
            <el-option label="全部" value="" hidden></el-option>
            <el-option v-for="item in activityTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打款状态">
          <el-select clearable v-model="searchForm.state">
            <el-option label="全部" value="" hidden></el-option>
            <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="补贴方式">
          <el-select v-model="searchForm.subsidyType" clearable>
            <el-option v-for="(val,key) in subsidyTypeMap" :key="key" :value="key" :label="val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行卡号">
          <el-input v-model.trim="searchForm.bankAccount" clearable placeholder="请输入银行卡号"></el-input>
        </el-form-item>
        <el-form-item label="结算账户类型">
          <el-select v-model="searchForm.bankAccountType" clearable>
            <el-option label="全部" value="" hidden></el-option>
            <el-option v-for="item in bankAccountTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" label="查询" :loading="searchLoading" @click.native="search"></auth-button>
          <auth-button opt="export" label="导出" :plain="true" :loading="exportLoading" @click.native="exportDetail"></auth-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="searchAgentForm" v-show="subsidyFlag !== 'merchant'">
        <el-form-item label="补贴时间">
          <date-range-picker :value="payTime" @change="value => payTime = value" ref="payTime" @getChange="dateChange" :maxRange="31" :disabledBefore="disabledBefore"></date-range-picker>
        </el-form-item>
        <el-form-item label="活动编号">
          <el-input v-model="searchAgentForm.activityId" clearable placeholder="请输入活动编号"></el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <!-- <el-input v-model="searchAgentForm.activityName" clearable placeholder="请输入活动名称"></el-input> -->
          <!-- <el-select clearable v-model="searchAgentForm.activityName" placeholder="请选择活动名称" filterable>
            <el-option v-for="item in activityList" :key="item.code" :label="item.name" :value="item.name"/>
          </el-select> -->
          <el-autocomplete
          v-model="searchAgentForm.activityName"
          :fetch-suggestions="querySearch"
          placeholder="请输入活动名称"
          :trigger-on-focus="false"
          value-key="name"
          clearable
          style="width: 202px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="银行名称">
          <el-input v-model.trim="searchAgentForm.bankName" clearable placeholder="请输入银行名称"></el-input>
        </el-form-item>
        <el-form-item label="银行编号">
          <el-input v-model.trim="searchAgentForm.bankCode" clearable placeholder="请输入银行编号"></el-input>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model="searchAgentForm.agentId" clearable placeholder="请输入代理商编号"></el-input>
        </el-form-item>
        <el-form-item label="活动类型">
          <el-select clearable v-model="searchAgentForm.activityType">
            <el-option label="全部" value="" hidden></el-option>
            <el-option v-for="item in activityTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入账状态">
          <el-select clearable v-model="searchAgentForm.state">
            <el-option label="全部" value="" hidden></el-option>
            <el-option label="入账成功" :value="1"></el-option>
            <el-option label="入账失败" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="补贴方式">
          <el-select v-model="searchAgentForm.subsidyType" clearable>
            <el-option v-for="(val,key) in subsidyTypeMap" :key="key" :value="key" :label="val"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <auth-button opt="search" label="查询" :loading="searchLoading" @click.native="search"></auth-button>
          <auth-button opt="export" label="导出" :plain="true" :loading="exportLoading" @click.native="exportDetail"></auth-button>
        </el-form-item>
      </el-form>
    </module-card>
    <h1 style="font-size: 18px; margin-bottom: 20px">补贴出款总金额(元)：{{ countAmount }}</h1>
    <module-card title="补贴出款明细">
      <el-table class="table" border :data="list" v-loading="searchLoading" v-show="subsidyFlag === 'merchant'">
        <el-table-column
          prop="createTime"
          label="打款时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="activityType"
          label="活动类型"
          width="120">
          <template slot-scope="scope">
            {{ getListText(scope.row.activityType, activityTypeList) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="activityId"
          label="活动编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="activityName"
          label="活动名称"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="bankName"
          label="银行名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="bankCode"
          label="银行编号"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="billId"
          label="打款单号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="商户编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="agentId1g"
          label="一代编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="agentId1gTitle"
          label="一代名称"
          min-width="120"
          v-if="!isBank">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="agentTitle"
          label="直属代理商名称"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="bankHolder"
          label="入账人姓名"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="bankAccount"
          label="银行卡号"
          width="150">
          <template slot-scope="scope">
              <span @dblclick="showbankAccount(scope.$index)">
                  {{ bankAccountList.indexOf(scope.$index) !== -1 ? scope.row.bankAccount : scope.row.bankAccount.replace(/^(\d{4})\d+(\d{4})$/, '$1********$2') }}
              </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bankBranch"
          label="支行"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="打款金额(元)"
          min-width="120">
          <template slot-scope="scope">
            {{ (scope.row.amount / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          label="打款状态"
          min-width="150">
          <template slot-scope="scope">
            {{ getListText(scope.row.state, stateList) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batchId"
          label="活动奖励批次号"
          width="120">
        </el-table-column>
        <el-table-column
          min-width="120"
          prop="subsidyType"
          label="补贴方式">
          <template slot-scope="scope">
            {{subsidyTypeMap[scope.row.subsidyType]}}
          </template>
        </el-table-column>
        <el-table-column
          prop="bankHolder"
          label="结算账户类型"
          min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.bankAccountType === 1 ? '对私结算' : '对公结算' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="taxCommission"
          label="税点比例"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="taxAmount"
          label="扣税金额（元）"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="failReason"
          label="失败原因"
          min-width="120">
          <template slot-scope="scope">
            {{ scope.row.failReason || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="subsidyMonth"
          label="补贴月份"
          width="150">
          <template slot-scope="scope">
            {{ scope.row.subsidyMonth || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150">
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="150">
          <template slot-scope="scope">
            <auth-button v-if="scope.row.state == 2 && scope.row.activityType != 10" opt="sync_status" label="同步状态" @click.native="syncState(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table class="table" border :data="list" v-loading="searchLoading" v-show="subsidyFlag !== 'merchant'">
        <el-table-column
          prop="subsidyTime"
          label="补贴时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="entryTime"
          label="入账时间"
          width="180">
          <template slot-scope="scope">
            {{ scope.row.entryTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="activityType"
          label="活动类型"
          width="180">
          <template slot-scope="scope">
            {{ getListText(scope.row.activityType, activityTypeList) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="activityId"
          label="活动编号">
        </el-table-column>
        <el-table-column
          prop="activityName"
          label="活动名称">
        </el-table-column>
        <el-table-column
          prop="bankName"
          label="银行名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="bankCode"
          label="银行编号"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="一代编号"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="agentName"
          label="一代名称"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="subsidyMonth"
          label="补贴月份"
          width="180">
        </el-table-column>
        <!-- <el-table-column
          min-width="120"
          prop="subsidyType"
          label="补贴方式">
          <template slot-scope="scope">
            {{subsidyTypeMap[scope.row.subsidyType]}}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="amountYuan"
          label="入账金额(元)">
        </el-table-column>
        <el-table-column
          prop="state"
          label="入账状态"
          width="150">
          <template slot-scope="scope">
            {{ scope.row.state === 1 ? '入账成功' : '入账失败' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="detail"
          label="详情"
          width="200">
          <template slot-scope="scope">
            <auth-button opt="search" label="查看商户补贴明细" @click.native="getMerchantSubsidyDetail(scope.row)" authType="span"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </module-card>
    <el-col :span="24" class="btm-action">
      <pagination @changePage="onChangeCurrentPage" :count="pagination.count" :page-no="pagination.pageNo" :size="pagination.pageSize"></pagination>
    </el-col>
    <dialog-info title="查看商户补贴明细" :visible.sync="showMerchantSubsidyDetail" size="large" :showCancelBtn="false" :showConfirmBtn="false" >
      <el-form :inline="true">
        <el-form-item label="商户编号">
          <el-input v-model="detailMerchantId" clearable placeholder="请输入商户编号"></el-input>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" label="查询" :loading="detailLoading" @click.native="getDetailList"></auth-button>
          <auth-button opt="export" label="导出" :plain="true" :loading="detailExportLoading" @click.native="exportMerchantDetail"></auth-button>
        </el-form-item>
      </el-form>
      <el-table border :data="detailList" v-loading="detailLoading">
        <el-table-column
          prop="merchantId"
          label="商户编号">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商编号">
        </el-table-column>
        <el-table-column
          prop="agentTitle"
          label="直属代理商名称">
        </el-table-column>
        <el-table-column
          prop="month"
          label="补贴月份">
          <template slot-scope="scope">
            {{ scope.row.month || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="amountYuan"
          label="补贴金额（元）">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
      </el-table>
      <pagination
        :count="detailPagination.total"
        :page-no="detailPagination.pageNo"
        :size="detailPagination.pageSize"
        @changePage="value => { detailPagination.pageNo = value;getDetailList() }"
        @changeSize="value => { detailPagination.pageSize = value;detailPagination.pageNo = 1;getDetailList() }"
      ></pagination>
    </dialog-info>
  </div>
</template>
<script>
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { downJumpConfirm, formateDate } from '@/assets/js/utils'
import dialogInfo from '@/components/layout/dialogInfo'
export default {
  name: 'subsidyDetail',
  components: {
    dateRangePicker,
    pagination,
    dialogInfo
  },
  data () {
    return {
      subsidyTypeMap: {
        '': '全部',
        1: '额度包补贴',
        2: '后返补贴'
      },
      disabledBefore: new Date().setMonth(new Date().getMonth() - 12),
      bankAccountList: [],
      payTime: [],
      searchForm: {
        billId: '',
        merchantId: '',
        agentId1g: '',
        agentId: '',
        activityType: '',
        state: '',
        startTime: '',
        endTime: '',
        activityName: '',
        activityId: '',
        bankAccount: '',
        bankName: '',
        bankCode: '',
        subsidyType: '',
        bankAccountType: ''
      },
      searchAgentForm: {
        billId: '',
        merchantId: '',
        agentId1g: '',
        agentId: '',
        activityType: '',
        state: '',
        startTime: '',
        endTime: '',
        activityName: '',
        activityId: '',
        bankName: '',
        bankCode: ''
      },
      pagination: {
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      list: [],
      // activityList: [],
      searchLoading: false,
      exportLoading: false,
      activityTypeList: [
        {
          value: 10,
          label: '月返'
        }, {
          value: 20,
          label: '实时返'
        }, {
          value: 30,
          label: '实时返非0费率'
        }
      ],
      stateList: [
        {
          value: 0,
          label: '初始化状态'
        }, {
          value: 1,
          label: '金额冻结成功'
        }, {
          value: 2,
          label: '金额冻结失败'
        }, {
          value: 3,
          label: '冻结结果未知'
        }, {
          value: 4,
          label: '商户打款禁用'
        }, {
          value: 5,
          label: '被拦截<未发起付款>'
        }, {
          value: 6,
          label: '打款中'
        }, {
          value: 7,
          label: '付款成功'
        }, {
          value: 8,
          label: '付款失败'
        }, {
          value: 9,
          label: '金额解冻转账成功'
        }, {
          value: 10,
          label: '金额解冻转账失败'
        }, {
          value: 11,
          label: '金额解冻转账结果未知'
        }, {
          value: 12,
          label: '金额解冻成功'
        }, {
          value: 13,
          label: '金额解冻失败'
        }, {
          value: 14,
          label: '金额解冻结果未知'
        }, {
          value: 15,
          label: '退票成功'
        }, {
          value: 16,
          label: '退票失败'
        }, {
          value: 17,
          label: '退票结果未知'
        }, {
          value: 18,
          label: '打款单被合并'
        }, {
          value: 19,
          label: '提交打款失败，允许重新打款'
        }, {
          value: 20,
          label: '申请退票'
        }, {
          value: 21,
          label: '止付请求状态未知'
        }, {
          value: 22,
          label: '禁止结算商户资金转移成功'
        }, {
          value: 23,
          label: '禁止结算商户资金转移未知'
        }, {
          value: 24,
          label: '金额转账成功'
        }, {
          value: 25,
          label: '金额转账未知'
        }
      ],
      subsidyFlag: 'merchant',
      showMerchantSubsidyDetail: false,
      currentMerchant: null,
      detailMerchantId: '',
      detailList: [],
      detailLoading: false,
      detailPagination: {
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      detailExportLoading: false,
      countAmount: '',
      bankAccountTypeList: [
        { value: 2, label: '对公结算' },
        { value: 1, label: '对私结算' }
      ]
    }
  },
  mounted () {
    const endTime = formateDate(new Date()).substring(0, 10) + ' 23:59:59'
    const startTime = formateDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)).substring(0, 10) + ' 00:00:00'
    this.payTime = [startTime, endTime]
    this.getList()
    // this.getActivityList()
  },
  methods: {
    // getActivityList () {
    //   this.searchLoading = true
    //   this.$axios.post(this.$api.queryListByName, { name: '' }).then(res => {
    //     console.log(res)
    //     this.searchLoading = false
    //     if (res.respCode === '0') {
    //       this.activityList = res.data
    //     }
    //   })
    // },
    syncState ({ billId }) {
      this.$axios.post(this.$api.synStatus, { billId }).then(res => {
        if (res.respCode === '0') {
          this.getList()
          this.$message({
            type: 'success',
            message: '同步成功'
          })
        }
      })
    },
    showbankAccount (value) {
      if (this.bankAccountList.indexOf(value) === -1) {
        this.bankAccountList.push(value)
      } else {
        this.bankAccountList.forEach((item, index) => {
          if (item === value) {
            this.bankAccountList.splice(index, 1)
          }
        })
      }
    },
    dateChange (value) {
      this.payTime = value
    },
    getList () {
      if (!this.payTime || !this.payTime[0] || !this.payTime[1]) {
        this.$message({
          type: 'error',
          message: '请选择时间进行查询',
          showClose: true
        })
        return
      }
      let searchApi, params
      if (this.subsidyFlag === 'merchant') {
        searchApi = 'subsidyDetailList'
        this.searchForm.startTime = this.payTime && this.payTime[0] ? this.payTime[0] : ''
        this.searchForm.endTime = this.payTime && this.payTime[1] ? this.payTime[1] : ''
        params = Object.assign({}, this.pagination, this.searchForm)
      } else {
        searchApi = 'agentSubsidyDetailList'
        this.searchAgentForm.startTime = this.payTime && this.payTime[0] ? this.payTime[0] : ''
        this.searchAgentForm.endTime = this.payTime && this.payTime[1] ? this.payTime[1] : ''
        params = Object.assign({}, this.pagination, this.searchAgentForm)
      }
      const currentFlag = this.subsidyFlag
      this.searchForm.startTime = this.payTime && this.payTime[0] ? this.payTime[0] : ''
      this.searchForm.endTime = this.payTime && this.payTime[1] ? this.payTime[1] : ''
      this.searchLoading = true
      this.$axios.post(this.$api[searchApi], params).then((res) => {
        this.searchLoading = false
        if (res.respCode === '0' && currentFlag === this.subsidyFlag) {
          this.list = res.data.list
          this.pagination.count = res.data.count
          this.countAmount = res.data.countAmount
        }
      })
    },
    onChangeCurrentPage (value) {
      this.pagination.pageNo = value
      this.getList()
    },
    search () {
      this.pagination.pageNo = 1
      this.getList()
    },
    exportDetail () {
      if (!this.payTime || !this.payTime[0] || !this.payTime[1]) {
        this.$message({
          type: 'error',
          message: '请选择时间进行导出',
          showClose: true
        })
        return
      }
      let exportApi, params
      if (this.subsidyFlag === 'merchant') {
        exportApi = 'exportSubsidyDetail'
        this.searchForm.startTime = this.payTime && this.payTime[0] ? this.payTime[0] : ''
        this.searchForm.endTime = this.payTime && this.payTime[1] ? this.payTime[1] : ''
        params = Object.assign({}, this.searchForm)
      } else {
        exportApi = 'exportAgentSubsidyDetail'
        this.searchAgentForm.startTime = this.payTime && this.payTime[0] ? this.payTime[0] : ''
        this.searchAgentForm.endTime = this.payTime && this.payTime[1] ? this.payTime[1] : ''
        params = Object.assign({}, this.searchAgentForm)
      }
      const that = this
      this.exportLoading = true
      this.$axios.post(this.$api[exportApi], params).then((res) => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(that)
        }
      })
    },
    getListText (value, list) {
      const result = list.filter(item => {
        return item.value === value
      })
      if (result.length === 1) {
        return result[0].label
      } else {
        return '未知'
      }
    },
    getMerchantSubsidyDetail (row) {
      this.showMerchantSubsidyDetail = true
      this.currentMerchant = JSON.parse(JSON.stringify(row))
      this.getDetailList()
    },
    getDetailList () {
      this.detailLoading = true
      this.$axios.post(this.$api.agentSubsidyListDetail, Object.assign({}, this.detailPagination, {
        batchId: this.currentMerchant.batchId,
        merchantId: this.detailMerchantId,
        agentId: this.currentMerchant.agentId
      })).then(res => {
        this.detailLoading = false
        if (res.respCode === '0') {
          this.detailList = res.data.list
          this.detailPagination.total = res.data.count
        }
      })
    },
    exportMerchantDetail () {
      const that = this
      this.detailExportLoading = true
      this.$axios.post(this.$api.agentSubsidyDetailExport, Object.assign({}, {
        batchId: this.currentMerchant.batchId,
        merchantId: this.detailMerchantId,
        agentId: this.currentMerchant.agentId
      })).then(res => {
        this.detailExportLoading = false
        this.showMerchantSubsidyDetail = false
        if (res.respCode === '0') {
          downJumpConfirm.call(that)
        }
      })
    },
    querySearch (queryString, cb) {
      const result = []
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (queryString === '') {
          cb(result)
        } else {
          this.$axios.post(this.$api.activityFuzzySearch, {
            name: queryString
          }).then(res => {
            if (res.respCode === '0') {
              var result = res.data
              cb(result)
            } else {
              result = []
              cb(result)
            }
          })
        }
      }, 1000)
    }
  },
  computed: {
    isBank () {
      return this.$store.state.userInfo.userType === 4
    }
    /* bankaccount () {
      return this.$set(this.list[0], 'bankAccount', 'dsad')
      for (var i = 0; i < this.list.length; i++) {
        return this.$set(this.list[i], 'bankAccount', 'dsad')
      }
    } */
  }
}
</script>

<style scoped lang="less">
.statisticDiv{
  background: #F7F8FB;
  width: 100%;
  padding: 65px 0;
  box-sizing: border-box;
  .statisticData{
    border-right: #D3D8E4;
    flex: 1;
    text-align: center;
    border-right: solid 1px #D3D8E4;
    &:nth-child(6n+6){
      border-right: none;
    }
    .numberFont{
      color: #16213D;
      font-size: 32px;
      margin-bottom: 14px;
    }
  }
}
</style>
